import {
  ModelConceptRelationship,
  ModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { LinkData, NodeData } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptRelationship,
  isModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getConnectedRelationshipDataForClass = (
  { linkDataArray }: { linkDataArray: LinkData[] },
  iri: string
) => {
  return linkDataArray.filter(
    (linkData): linkData is ModelConceptRelationship =>
      isModelConceptRelationship(linkData) &&
      (linkData.from === getModelConceptClassKey(iri) ||
        linkData.to === getModelConceptClassKey(iri))
  );
};

export const getConnectedRelationshipLabelDataForClass = (
  { nodeDataArray }: { nodeDataArray: NodeData[] },
  iri: string
) => {
  return nodeDataArray.filter(
    (nodeData): nodeData is ModelConceptRelationshipLabel =>
      isModelConceptRelationshipLabel(nodeData) &&
      (nodeData.from === getModelConceptClassKey(iri) ||
        nodeData.to === getModelConceptClassKey(iri))
  );
};
